import React from 'react';

const Mining = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Mining & Resource Management</h2>
                <p>
                    Transform your mining operations with our advanced LiDAR surveying and monitoring solutions. Our technology provides accurate volumetric measurements, structural analysis, and topographic mapping that enhances safety, efficiency, and environmental compliance.
                </p>
                <p>
                    From stockpile volume calculations to pit wall stability monitoring and mine planning, our precision 3D models help optimize resource extraction while minimizing environmental impact and ensuring worker safety in challenging environments.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Stockpile Measurement</span>
                    <span className="feature-item">Pit Wall Stability</span>
                    <span className="feature-item">Environmental Monitoring</span>
                    <span className="feature-item">Site Planning</span>
                    <span className="feature-item">Production Tracking</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/mining.png" alt="Mining & Resource Management LiDAR Application" />
            </div>
        </div>
    );
};

export default Mining;